import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'round'})
export class RoundPipe implements PipeTransform {
   /**
    *
    * @param value
    * @returns {number}
    */
   transform(value: number): number {
       return Math.ceil(value);
   }
}



// WEBPACK FOOTER //
// ./src/app/pipes/round.pipe.ts